import React from 'react'
import {setLocalStorageItem} from "../functions"

export const NetPhonePage = () => {
    setLocalStorageItem('page', 'NetPhonePage')

    return (
        <>
            <div className={'container text-center'}>
                <h4 className={'mt-3'}>{"Эта страница пока в разработке и отключена!"}</h4>
                <h5>{"Как только она начнет работать мы обязательно её включим!"}</h5>
            </div>
        </>
    )
}